import { Box, BoxProps } from "@mui/material";
import { FC } from "react";

const boxStyles = {
  position: "fixed",
  width: "100vw",
  height: "100vh",
  inset: 0,
  zIndex: 3000,
  backgroundColor: "white",
  overflowY: "auto",
} as const;

const CustomBoxWrapper: FC<BoxProps> = ({ children, sx, ...boxProps }) => {
  return (
    <Box {...boxProps} sx={[boxStyles, ...(Array.isArray(sx) ? sx : [sx])]}>
      {children}
    </Box>
  );
};

export default CustomBoxWrapper;
